/**
 * What a gym keeps from one online payment, for the Payments tab.
 *
 * These mirror the Worker: PLATFORM_FEE_RATE, PLATFORM_FEE_MIN_BANI and
 * PLATFORM_FEE_CAP_BANI in workers/api/src/stripe.ts, and Stripe's European
 * card price. Change them
 * together with the Worker and the feesStripe / feesPlatform copy, or the tab
 * promises one split and the order shows another.
 */
export const STRIPE_RATE = 0.015
export const STRIPE_FIXED_LEI = 1
export const PLATFORM_RATE = 0.006
export const PLATFORM_MIN_LEI = 0.5
export const PLATFORM_CAP_LEI = 1.5

/** Whole lei, rounded to the ban, the way Stripe rounds. */
const toBani = (lei: number) => Math.round(lei * 100)

export interface FeeBreakdown {
  price: number
  stripe: number
  platform: number
  net: number
  /** The gym's share of the price, 0–100, one decimal. */
  keepPercent: number
}

export function feeBreakdown(price: number): FeeBreakdown {
  const priceBani = toBani(price)
  const stripeBani = toBani(price * STRIPE_RATE + STRIPE_FIXED_LEI)
  const platformBani =
    priceBani > 0
      ? Math.min(
          Math.max(toBani(price * PLATFORM_RATE), toBani(PLATFORM_MIN_LEI)),
          toBani(PLATFORM_CAP_LEI),
          priceBani,
        )
      : 0
  const netBani = Math.max(priceBani - stripeBani - platformBani, 0)
  return {
    price,
    stripe: stripeBani / 100,
    platform: platformBani / 100,
    net: netBani / 100,
    keepPercent: priceBani > 0 ? Math.round((netBani / priceBani) * 1000) / 10 : 0,
  }
}

/** Shown when a gym has fewer than two plans of its own to use as examples. */
export const SAMPLE_PRICES = [50, 150, 275, 600]
